import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { ElementsState } from './types';

export const elementsSlice = createSlice({
    name: 'elements',
    initialState,
    reducers: {
        setLayoutAdmin: (state, action: PayloadAction<ElementsState['layoutAdmin']>) => {
            // @ts-ignore
            state.layoutAdmin = action.payload;
        },
    },
});

export const { setLayoutAdmin } = elementsSlice.actions;

export default elementsSlice.reducer;
